export const loanType = [
  {
    id: 0,
    title: "General",
    value: "General",
  },
];
export const permitsDevelopmentStatus = [
  {
    id: 1,
    title: "Obtained/Approved",
    value: "obtained/approved",
  },
  {
    id: 2,
    title: "Submitted",
    value: "submitted",
  },
  {
    id: 3,
    title: "Not Submitted",
    value: "not-submitted",
  },
];

export const buildingPermitStatus = [
  {
    id: 1,
    title: "Obtained/Approved",
    value: "obtained/approved",
  },
  {
    id: 2,
    title: "Submitted",
    value: "submitted",
  },
  {
    id: 3,
    title: "Not Submitted",
    value: "not-submitted",
  },
];

export const appraisalThirdPartyAvailable = [
  {
    id: 1,
    title: "Unavailable",
    value: false,
  },
  {
    id: 2,
    title: "Available",
    value: true,
  },
];

export const servicingCompletedList = [
  {
    id: 1,
    title: "Complete",
    value: true,
  },
  {
    id: 2,
    title: "Incomplete",
    value: false,
  },
];
